import { _ as __assign } from '../../chunks/bundle-j5GfJ6DZ.js';
import React__default from 'react';
import { R as RemoveMessageModalView } from '../../chunks/bundle-gFEGYRmO.js';
import { u as useGroupChannel } from '../../chunks/bundle-BykuFiQC.js';
import '../../chunks/bundle-B4W1Qw_4.js';
import 'react-dom';
import '../../chunks/bundle-idC_wVZi.js';
import '../../chunks/bundle-BSUtC3cw.js';
import '../../chunks/bundle-BjDPDV1u.js';
import '../../chunks/bundle-CnQtgeX8.js';
import '../../chunks/bundle-DvCKSiBl.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-ZBp236Ey.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-B7LMd75S.js';
import '../../chunks/bundle-DloqDvm2.js';
import '../../chunks/bundle-BC1GKYVu.js';
import '../../chunks/bundle-C6g3HNED.js';
import '@sendbird/chat';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-B19WxiWc.js';
import '../../chunks/bundle-EMEHizdG.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-Bzoj1u3h.js';
import '../../chunks/bundle-Cj_4CfJM.js';
import '../../chunks/bundle-RVsnVYbw.js';
import '@sendbird/chat/message';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-S7XE7Lfi.js';
import '../../chunks/bundle-BSLHBsOu.js';
import '../../chunks/bundle-44j0QAmj.js';
import '../../chunks/bundle-CPQL3IZE.js';
import '../../chunks/bundle-CHW7NXXK.js';
import '../../chunks/bundle--h0f5LUC.js';
import '../../chunks/bundle-u2dy86rx.js';
import '../../chunks/bundle-CxpAk_cb.js';

var RemoveMessageModal = function (props) {
    var deleteMessage = useGroupChannel().actions.deleteMessage;
    return React__default.createElement(RemoveMessageModalView, __assign({}, props, { deleteMessage: deleteMessage }));
};

export { RemoveMessageModal, RemoveMessageModal as default };
//# sourceMappingURL=RemoveMessageModal.js.map
